export default __webpack_public_path__ + "static/media/wait.f9b0a20f.gif";